import React from 'react';
import { Box, IconButton, Typography, Avatar } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const FilePreviewSingle = ({
  url,
  name = '',
  type = 'image',
  style = { width: '100px', height: '100px', objectFit: 'cover' },
  deleteFile
}) => {
  return (
    <Box position="relative" display="inline-block" className="file-section">
      <Box className="choose-img" ml={2}>
        {type === 'image' ? (
          <Avatar
            variant="rounded"
            src={url}
            alt={name}
            sx={style}
          />
        ) : (
          <Typography variant="body2">{name}</Typography>
        )}
      </Box>
      {deleteFile && (
        <IconButton
          onClick={() => deleteFile()}
          sx={{
            position: 'absolute',
            top: 0,
            right: 0,
            padding: '2px',
            color: 'gray'
          }}
          aria-label="delete"
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      )}
    </Box>
  );
};

export default FilePreviewSingle;


// import React, { useState } from 'react';
// import { Col, Dropdown, Form, Image, Row, Button } from 'react-bootstrap';
// import CloseButton from 'react-bootstrap/CloseButton';

// const FilePreviewSingle = ({ url, name = '', type = 'image',style={ width: '100px', height: '100px', objectFit: 'cover' }, deleteFile }) => {
//   return (
//     <div className="file-section">
//       <div className="ms-2 choose-img">
//         {type === 'image' ? <Image src={`${url}`} alt={name} style={style}  /> : { name }}
//       </div>
//       {deleteFile && (
//         <span className="image-position">
//           <CloseButton onClick={() => deleteFile()} className="close-icon" aria-label="Hide" />
//         </span>
//       )}
//     </div>
//   );
// };

// export default FilePreviewSingle;
